/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Ab_Pitch_PInputs */

const es_ab_pitch_p = /** @type {(inputs: Ab_Pitch_PInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Te conectamos con quien busca alquilar barcos como el tuyo. Tú decides precio, fechas y condiciones — del papeleo nos ocupamos nosotros.`)
};

const gl_ab_pitch_p = /** @type {(inputs: Ab_Pitch_PInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Conectámoste con quen busca alugar barcos como o teu. Ti decides prezo, datas e condicións — do papeleo ocupámonos nós.`)
};

const en_ab_pitch_p = /** @type {(inputs: Ab_Pitch_PInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`We connect you with people looking to rent boats like yours. You set price, dates, and terms — we handle the paperwork.`)
};

/**
* | output |
* | --- |
* | "We connect you with people looking to rent boats like yours. You set price, dates, and terms — we handle the paperwork." |
*
* @param {Ab_Pitch_PInputs} inputs
* @param {{ locale?: "es" | "gl" | "en" }} options
* @returns {LocalizedString}
*/
export const ab_pitch_p = /** @type {((inputs?: Ab_Pitch_PInputs, options?: { locale?: "es" | "gl" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Ab_Pitch_PInputs, { locale?: "es" | "gl" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "gl") return gl_ab_pitch_p(inputs)
	if (locale === "en") return en_ab_pitch_p(inputs)
	return es_ab_pitch_p(inputs)
});